import React from 'react';
import Button from "./../components/function/button/button";
import "./cta.css";
const CTA = (props) => {
    return (
        <div className={`cta ${props.visible ? "animated" : "opa-0"}`}>
            <div className={`cta-img ${props.visible ? "animated fadeInLeft" : "opa-0"}`}><img src={props.content.img.src} alt={props.content.img.alt}/></div>
            <div className={`cta-text montserrat fw-bold ${props.visible ? "animated fadeInUp" : "opa-0"}`} ><p dangerouslySetInnerHTML={{ __html: props.content.text }}/></div>
            <div className="cta-button"><Button style={{ marginTop: "1rem" }} text={props.content.btn.text} href="#Intro"/></div>
        </div>
    );
};

export default CTA;


// WEBPACK FOOTER //
// ./src/sections/Cta.js